import { render } from "./LogOut.vue?vue&type=template&id=afd0d950&scoped=true&ts=true"
import script from "./LogOut.vue?vue&type=script&lang=ts"
export * from "./LogOut.vue?vue&type=script&lang=ts"

import "./LogOut.vue?vue&type=style&index=0&id=afd0d950&lang=scss&scoped=true"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afd0d950"]])

export default __exports__